/**
 * Approved client & partner logos, cropped from the company's logo sheet.
 * Boxes are in source pixels on a 1536×864 reference frame of the sheet.
 */
export const LOGO_SHEET =
  'https://cdn.magicpatterns.com/uploads/9uq9mUVRCt2fw1WDHL3APt/30.png'
export const SHEET_W = 1536

export type Logo = {
  id: string
  name: string
  x: number
  y: number
  w: number
  h: number
}

export const logos = {
  sony: { id: 'sony', name: 'Sony Innovation Fund', x: 1140, y: 92, w: 145, h: 122 },
  worldBank: { id: 'worldBank', name: 'World Bank Group', x: 735, y: 52, w: 365, h: 82 },
  ibm: { id: 'ibm', name: 'IBM', x: 1312, y: 124, w: 120, h: 52 },
  rogers: { id: 'rogers', name: 'Rogers Cybersecure Catalyst', x: 848, y: 144, w: 237, h: 80 },
  measured: { id: 'measured', name: 'Measured Capital', x: 775, y: 292, w: 345, h: 52 },
  royce: { id: 'royce', name: 'Royce Investment Partners', x: 1203, y: 304, w: 217, h: 76 },
  blackTech: { id: 'blackTech', name: 'BlackTech Capital', x: 860, y: 392, w: 216, h: 58 },
  gx: { id: 'gx', name: 'GX Ventures', x: 1170, y: 450, w: 222, h: 54 },
  blueVision: { id: 'blueVision', name: 'Blue Vision Capital', x: 862, y: 495, w: 222, h: 125 },
  village: { id: 'village', name: 'Village Capital', x: 1168, y: 556, w: 230, h: 48 },
  altitude: { id: 'altitude', name: 'Altitude Accelerator', x: 828, y: 672, w: 148, h: 146 },
  techstars: { id: 'techstars', name: 'Techstars', x: 1074, y: 718, w: 254, h: 52 },
} satisfies Record<string, Logo>

/** Logo wall order — enterprise and institutional names lead. */
export const logoWall: Logo[] = [
  logos.sony,
  logos.worldBank,
  logos.ibm,
  logos.techstars,
  logos.rogers,
  logos.village,
  logos.measured,
  logos.royce,
  logos.blackTech,
  logos.gx,
  logos.blueVision,
  logos.altitude,
]

/** Monochrome-safe subset for dark backgrounds (no filled brand boxes). */
export const coverLogos: Logo[] = [
  logos.sony,
  logos.worldBank,
  logos.ibm,
  logos.techstars,
  logos.village,
  logos.measured,
]

export const MAP_IMAGE =
  'https://cdn.magicpatterns.com/patterns/generated-images/6e419700-4d89-4ae1-9120-9f96e1927ad2.jpg'
export const GLOBE_IMAGE =
  'https://cdn.magicpatterns.com/patterns/generated-images/357f7a7f-d4f5-45c5-9eaf-cc9a7a0491a4.jpg'
